import type { BasePaginationDto } from '@@types/api.types';
import { AdminPagination } from '@components/ui/admin-pagination';
import React from 'react';

type AdminDomainsPaginationProps = {
  isFetching?: boolean;
  onLimitChange: (limit: number) => void;
  onNextPage: () => void;
  onPreviousPage: () => void;
  pagination: BasePaginationDto;
};

export const AdminDomainsPagination: React.FC<AdminDomainsPaginationProps> = (props) => {
  const { isFetching, onLimitChange, onNextPage, onPreviousPage, pagination } = props;

  return (
    <AdminPagination
      isFetching={isFetching}
      itemLabel="domains"
      onLimitChange={onLimitChange}
      onNextPage={onNextPage}
      onPreviousPage={onPreviousPage}
      pagination={pagination}
    />
  );
};
